import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  HStack,
  Image,
  Button,
  VStack,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { COLORS } from "../../../../Helper/Colors";
import { CloudArrowUp } from "phosphor-react";
import placeHolder from "../../../../Assets/profile_placeholder.jpg";

export const ImageInput = ({
  label,
  placeholder,
  reference,
  name,
  value,
  error,
  touched,
  handleChange,
  isRequired = false,
  btnSize = "md",
  ...rest
}) => {
  const imageProps =
    rest.imageWidth && rest.imageHeight
      ? { width: rest.imageWidth, height: rest.imageHeight }
      : rest.imageWidth
      ? { width: rest.imageWidth, objectFit: "contain" }
      : { height: rest.imageHeight || "75px", objectFit: "contain" };
  const props = rest.width ? { width: rest.width } : { flex: 1 };
  return (
    <FormControl
      {...props}
      isRequired={isRequired}
      isInvalid={!!error && touched}
    >
      <FormLabel color={COLORS.mediumGray} htmlFor={name}>
        {label}
      </FormLabel>
      <input
        id={name}
        name={name}
        type="file"
        ref={reference}
        accept={rest.imageType || "image/*"}
        style={{ display: "none" }}
        onChange={(event) => handleChange(name, event.target.files[0])}
      />
      <HStack
        spacing={4}
        flexDirection={{ base: "column", md: "row", lg: "column", xl: "row" }}
      >
        {!error && value && (
          <Image
            {...imageProps}
            borderRadius={rest.borderRadius || "5px"}
            src={
              typeof value === "object"
                ? URL.createObjectURL(value)
                : placeHolder
            }
            // fallbackSrc={placeHolder}
            alt={name}
          />
        )}
        <VStack spacing={0}>
          <Button
            aria-label={placeholder}
            size={btnSize}
            variant="ghost"
            leftIcon={
              <CloudArrowUp size={24} color={COLORS.brand} weight="duotone" />
            }
            onClick={() => reference.current.click()}
            type="button"
            fontWeight={"light"}
            textDecoration="underline"
            textColor={COLORS.tableHeader}
            fontSize={"16px"}
            _hover={{ transform: "scale(0.97)" }}
            _active={{}}
            _focus={{}}
          >
            {placeholder}
          </Button>
          {rest.additionalInfo && (
            <Text color={COLORS.mediumGray} fontWeight={300} fontSize={"14px"}>
              {rest.additionalInfo}
            </Text>
          )}
        </VStack>
      </HStack>
      <FormErrorMessage
        justifyContent={{
          base: "center",
          md: "start",
          lg: "center",
          xl: "start",
        }}
      >
        {error}
      </FormErrorMessage>
    </FormControl>
  );
};
